module.exports = __webpack_public_path__ + "static/media/unforeseen-corners.bbc59d93.jpg";